import React from "react";
import { asArray, asSimpleArray } from "../utils/map";
import { vrTypesToString } from "../utils/appUtils";
const NONE = "NONE";

export const extractAppsApprovedByBundles = ({ contentBundles, selectedBundleKeys }) => {
  let approvedApps = {};
  selectedBundleKeys.map(bundleKey => {
    if (!contentBundles[bundleKey]) return;
    const { appRefs } = contentBundles[bundleKey];
    appRefs.map(
      ({ id }) => {
        approvedApps[id] = true;
      }
    );
  });
  return approvedApps;
};

export const amauntOfAppsInBundles = (contentBundles, contentBundleRefs) => {
  let amaunt = 0;
  contentBundleRefs.map(({ id }) => {
    if (!contentBundles[id]) return;
    const { appRefs } = contentBundles[id];
    amaunt += appRefs.length;
  });
  return amaunt;
};

export const extractAllApps = (apps) => {
  let managedApps = [];
  let externalApps = [];
  let genericKey = 0;
  asArray(apps).map(app => {
    const { key, apkUrl, iconUrl, title, packageName, vrTypes } = app;
    const row = [
      <img
        src={iconUrl}
        style={{ width: 50, margin: 5 }}
        key={genericKey++}
        alt="App Icon"
      />,
      title,
      packageName,
      vrTypesToString(vrTypes)
    ];
    if (apkUrl) managedApps.push({ key, row, title });
    else externalApps.push({ key, row, title });
  });
  return { managedApps, externalApps };
};

export const extractAvaliableAppOptions = ({ appsApprovedByBundles, apps, selectedApps }) => {
  let appOptionsAsObj = {};
  asArray(appsApprovedByBundles).map(({ key }) => {
    if (!apps[key]) return;

    appOptionsAsObj[key] = { value: key, label: apps[key].title }
  }
  );
  asArray(selectedApps).map(({ key }) => {
    if (!apps[key]) return;

    appOptionsAsObj[key] = { value: key, label: apps[key].title }
  }
  );
  const appOptions = [];
  asSimpleArray(appOptionsAsObj).map(s => appOptions.push(s));
  appOptions.sort((a, b) => a.label.localeCompare(b.label));
  return appOptions;
}

export const extractKioskAppOptions = ({ appsApprovedByBundles, apps, selectedApps }) => {
  const kioskAppOptions = extractAvaliableAppOptions({ appsApprovedByBundles, apps, selectedApps });
  kioskAppOptions.unshift({ value: NONE, label: <em>None</em> });
  return kioskAppOptions;
}

export const generateRegistrationCode = (length = 8) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}